export default __webpack_public_path__ + "static/media/spectra-com4.a9856bc1.jpg";